import firebase from 'firebase/app';
// This import loads the firebase namespace along with all its type information.
// These imports load individual services into the firebase namespace.
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/analytics';

const config = require('./app_config.json');

// Firebase
export const firebaseApp = firebase.initializeApp({
  apiKey: config.firebase.apiKey,
  authDomain: config.firebase.authDomain,
  databaseURL: config.firebase.databaseURL,
  projectId: config.firebase.projectId,
  storageBucket: config.firebase.storageBucket,
  messagingSenderId: config.firebase.messagingSenderId,
  appId: config.firebase.appId,
});
firebaseApp.analytics();

export const db = firebase.firestore();

// Auth0
// export const auth0 = ({
//     domain : config.auth0.domain,
//     clientId : config.auth0.clientID,
//     redirectUri : config.auth0.redirectUri
// })
